import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TrLoadingOverlay } from './tr-loading-overlay.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
    ],
    exports: [ TrLoadingOverlay ],
    declarations: [ TrLoadingOverlay ],
})
export class TrLoadingOverlayModule {}
